import { CSSProperties } from 'react';
import { Skill } from './types';
import CoreCard from './CoreCard';
import CoreWideCard from './CoreWideCard';
import SatelliteCard from './SatelliteCard';
import styles from './Skills.module.scss';

// Ordered for 2-row grid column auto-flow.
// wide CORE spans 2 cols × 2 rows; plain CORE spans 1 col × 2 rows;
// two consecutive SATELLITEs fill one column.
const SKILLS: Skill[] = [
  { id: 'figma', name: 'Figma', level: 81, variant: 'SATELLITE' },
  { id: 'storybook', name: 'Storybook', level: 68, variant: 'SATELLITE' },
  {
    id: 'frontend',
    name: 'Frontend',
    level: 82,
    variant: 'CORE',
    wide: true,
    subSkills: [
      { id: 'react', name: 'React', level: 92 },
      { id: 'react-query', name: 'React Query', level: 73 },
      { id: 'react-router', name: 'React Router', level: 83 },
      { id: 'redux', name: 'Redux', level: 84 },
      { id: 'mui-bootstrap', name: 'MUI & Bootstrap', level: 77 }
    ]
  },
  { id: 'typescript', name: 'TypeScript', level: 86, variant: 'CORE' },
  {
    id: 'api-design',
    name: 'API design',
    level: 65,
    variant: 'CORE',
    wide: true,
    subSkills: [
      { id: 'swagger-api', name: 'Swagger', level: 55 },
      { id: 'rest-api', name: 'REST API', level: 87 },
      { id: 'socketio', name: 'Socket.IO', level: 68 },
      { id: 'sse', name: 'SSE', level: 72 },
      { id: 'soap', name: 'SOAP', level: 44 }
    ]
  },
  { id: 'keycloak-sso', name: 'Keycloak & SSO', level: 69, variant: 'SATELLITE' },
  { id: 'redis', name: 'Redis', level: 41, variant: 'SATELLITE' },
  {
    id: 'backend',
    name: 'Backend',
    level: 64,
    variant: 'CORE',
    wide: true,
    subSkills: [
      { id: 'nodejs', name: 'Node.js', level: 79 },
      { id: 'express', name: 'Express.js', level: 83 },
      { id: 'nestjs', name: 'Nest.js', level: 64 },
      { id: 'plsql', name: 'PL/SQL', level: 58 },
      { id: 'supabase', name: 'Supabase', level: 36 }
    ]
  },
  {
    id: 'databases',
    name: 'Databases',
    level: 54,
    variant: 'CORE',
    wide: true,
    subSkills: [
      { id: 'postgresql', name: 'PostgreSQL', level: 67 },
      { id: 'mariadb', name: 'MariaDB', level: 41 },
      { id: 'oracledb', name: 'Oracle Database', level: 55 }
    ]
  },
  {
    id: 'ai',
    name: 'AI',
    level: 46,
    variant: 'CORE',
    wide: true,
    subSkills: [
      { id: 'prompt-engineering', name: 'Prompt Engineering', level: 52 },
      { id: 'mcp-integration', name: 'MCP Integration', level: 43 },
      { id: 'ai-workflows', name: 'AI Workflows', level: 48 },
      { id: 'code-gen-review', name: 'Code Gen & Review', level: 45 },
      { id: 'ai-debugging', name: 'AI Debugging', level: 41 }
    ]
  },
  { id: 'docker', name: 'Docker', level: 32, variant: 'SATELLITE' },
  { id: 'git', name: 'Git', level: 38, variant: 'SATELLITE' }
];

interface CardStyle extends CSSProperties {
  '--level': number;
}

const Skills = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.strip}>
        <ul className={styles.track}>
          {SKILLS.map((skill) => {
            const isCore = skill.variant === 'CORE';
            const cardStyle: CardStyle = { '--level': skill.level };
            const className = [
              styles.card,
              isCore ? styles.cardCore : styles.cardSatellite,
              skill.wide ? styles.cardWide : ''
            ]
              .filter(Boolean)
              .join(' ');

            return (
              <li key={skill.id} className={className} style={cardStyle}>
                {skill.wide ? (
                  <CoreWideCard skill={skill} />
                ) : isCore ? (
                  <CoreCard skill={skill} />
                ) : (
                  <SatelliteCard skill={skill} />
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default Skills;
